import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import Modal from "react-responsive-modal";
import * as ROUTES from '../../constants/routes';
import { withFirebase } from '../Firebase';
import Background from "../assets/login_background_mobile.svg";
import BackgroundDesktop from "../assets/login_background.svg";
import { withStyles } from '@material-ui/core/styles';
import ForgottenPasswordModalContent from "./ForgottenPasswordModalContent";

import "./SignIn.css";
import { Fade } from '@material-ui/core';

const styles = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
    },
    modal: {
        boxShadow: 'none',
        borderRadius: '5px',
        height: "258px",
        maxWidth: "376px",
        top: "20%",
        padding: "0px",
    }
};

const styles_loader = theme => ({
    root: {
    },
    buttonProgress: {
        color: '#FFFFFF',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -20,
        marginLeft: -15,
    },
});

class SignInPage extends Component {

    componentDidMount() {
    }
    render() {
        let width = window.innerWidth;
        if (width > 768) {
            return (
                <SignInForm />
            );
        } else {
            return (
                <SignInFormMobile />
            );
        }
    }

}

const INITIAL_STATE = {
    email: '',
    password: '',
    forgottenPwdOpen: false,
    error: null,
    errorMessage: null,
    signInLoading: false,
};

class SignInFormBase extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    onSubmit = event => {
        const { email, password } = this.state;
        this.setState({ signInLoading: true })

        this.props.firebase
            .doSignInWithEmailAndPassword(email, password)
            .then(() => {
                this.setState({ ...INITIAL_STATE, signInLoading: false });
                this.props.history.push(ROUTES.HOME);
            })
            .catch(error => {
                this.setState({ error, signInLoading: false });
                switch (error.code) {
                    case 'auth/user-not-found':
                        this.setState({ errorMessage: "Connexion échouée : email ou mot de passe incorrect" })
                        break;
                    default:
                        this.setState({ errorMessage: "Connexion échouée : Une erreur est survenue" })
                }
            });

        event.preventDefault();
    };

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    redirectSignUp = event => {
        this.props.history.push(ROUTES.SIGN_UP);
    }

    openForgottenPwd = () => {
        this.setState({
            forgottenPwdOpen: true
        })
    }

    closeForgottenPwd = () => {
        this.setState({
            forgottenPwdOpen: false
        })
    }

    render() {
        const { email, password, error, errorMessage, signInLoading } = this.state;
        const { classes } = this.props

        return (
            <div style={{ background: `url(${BackgroundDesktop}) no-repeat center fixed`, backgroundSize: 'cover', height: 'auto', minHeight: '100vh', width: 'auto', minWidth: '100vw' }}>
                <div className="h-auto">

                    <div className="row logo-container mr-0 ml-0">
                        <div className="col"></div>
                        <div className="col">
                            <img className="signin-logo" width="" src={require('../../assets/loading/logo_zideeUp.png')} alt="Logo" />
                            <div className="catch-line">
                                L'espace amélioration continue
                            </div>
                        </div>
                        <div className="col"></div>
                    </div>

                    <div className="row mr-0 ml-0">
                        <div className="col "></div>
                        <div className="col login-container">
                            <Fade in={true} timeout={1000}>
                                <form onSubmit={this.onSubmit}>
                                    <div className="login-form-container">
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="email" className="basic-text">Votre email</label>
                                                <input onChange={this.onChange} value={email} type="email" className="login-field container placeholder-label" name="email" aria-describedby="emailHelp" placeholder="email" />
                                            </div>
                                            <div className="form-group-margin">

                                                <label htmlFor="password" className="basic-text">Votre mot de passe</label>
                                                <input onChange={this.onChange} value={password} type="password" className="container login-field" name="password" placeholder="mot de passe" />
                                            </div>
                                            <div className="login-forgot-password-container">
                                                <p className="text-right forgot-password-text" onClick={() => this.openForgottenPwd()}>
                                                    Mot de passe oublié ?
                                                </p>
                                                {!this.state.forgottenPwdOpen && error && <p className="login-error">{errorMessage}</p>}
                                            </div>

                                        </div>
                                        <div className="position-relative p-5">
                                            {signInLoading && <CircularProgress size={35} className={classes.buttonProgress} />}
                                        </div>
                                        <div className="text-center">
                                            <button type="submit" className="signin-button">Se connecter</button>
                                            <button className="signup-button signup-text" onClick={this.redirectSignUp}>S'inscrire</button>
                                        </div>
                                    </div>
                                </form>
                            </Fade>
                        </div>
                        <div className="col"></div>



                    </div>
                </div>

                <Modal
                    open={this.state.forgottenPwdOpen}
                    onClose={this.closeForgottenPwd}
                    center
                    showCloseIcon={true}
                    styles={styles}
                >
                    <ForgottenPasswordModalContent onClose={this.closeForgottenPwd} />

                </Modal>
            </div>
        );
    }
}

class SignInFormBaseMobile extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    onSubmit = event => {
        const { email, password } = this.state;
        this.setState({ signInLoading: true })
        this.props.firebase
            .doSignInWithEmailAndPassword(email, password)
            .then(() => {
                this.setState({ ...INITIAL_STATE, signInLoading: false });
                this.props.history.push(ROUTES.HOME);
            })
            .catch(error => {
                this.setState({ error, signInLoading: false });
                switch (error.code) {
                    case 'auth/user-not-found':
                        this.setState({ errorMessage: "Connexion échouée : email ou mot de passe incorrect" })
                        break;
                    default:
                        this.setState({ errorMessage: "Connexion échouée : Une erreur est survenue" })
                }
            });

        event.preventDefault();
    };

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    redirectSignUp = event => {
        this.props.history.push(ROUTES.SIGN_UP);
    }

    openForgottenPwd = () => {
        this.setState({
            forgottenPwdOpen: true
        })
    }

    closeForgottenPwd = () => {
        this.setState({
            forgottenPwdOpen: false
        })
    }

    render() {
        const { email, password, error, errorMessage, signInLoading } = this.state;
        const { classes } = this.props

        return (
            <div style={{ background: `url(${Background}) no-repeat center fixed`, backgroundSize: 'cover', height: 'auto', minHeight: '100vh', width: 'auto', minWidth: '100vw' }}>
                <div className="h-100">

                    <div className="row logo-container mr-0 ml-0">
                        <img className="signin-logo-mobile" src={require('../../assets/loading/logo_zideeUp.png')} alt="Logo" />
                        <div className="catch-line">
                            L'espace amélioration continue
                        </div>
                    </div>

                    <div className="row mr-0 ml-0">
                        <div className="login-container">
                            <Fade in={true} timeout={1000}>
                                <form onSubmit={this.onSubmit}>

                                    <div className="login-form-container-mobile">

                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="email" className="basic-text">Votre email</label>
                                                <input onChange={this.onChange} value={email} type="email" className="login-field container placeholder-label" name="email" aria-describedby="emailHelp" placeholder="email" />
                                            </div>
                                            <div className="form-group-margin">

                                                <label htmlFor="password" className="basic-text">Votre mot de passe</label>
                                                <input onChange={this.onChange} value={password} type="password" className="container login-field" name="password" placeholder="mot de passe" />
                                            </div>
                                            <div className="login-forgot-password-container">
                                                <p className="text-right" onClick={() => this.openForgottenPwd()}>
                                                    <div className="forgot-password-text">Mot de passe oublié ?</div>
                                                </p>
                                                {!this.state.forgottenPwdOpen && error && <p>{errorMessage}</p>}
                                            </div>
                                        </div>
                                        <div className="position-relative p-5">
                                            {signInLoading && <CircularProgress size={35} className={classes.buttonProgress} />}
                                        </div>
                                        <div className="text-center">
                                            <button type="submit" className="signin-button">Se connecter</button>
                                            <button className="signup-button signup-text" onClick={this.redirectSignUp}>S'inscrire</button>
                                        </div>
                                    </div>

                                </form>
                            </Fade>
                        </div>
                    </div>
                </div>

                <Modal
                    open={this.state.forgottenPwdOpen}
                    onClose={this.closeForgottenPwd}
                    center
                    showCloseIcon={true}
                    styles={styles}
                >
                    <ForgottenPasswordModalContent onClose={this.closeForgottenPwd} />
                </Modal>
            </div>
        );
    }
}


const SignInForm = withRouter(withFirebase(withStyles(styles_loader)(SignInFormBase)));
const SignInFormMobile = withRouter(withFirebase(withStyles(styles_loader)(SignInFormBaseMobile)));


export default SignInPage;
export { SignInForm, SignInFormMobile };
